(function () {
  function init(root) {
    var nav = root.querySelector('[data-pp-nav]');
    if (!nav) return;
    var scrollbar = document.querySelector('[data-pp-scrollbar]');
    var overlap = document.querySelector('[data-pp-nav-overlap]');
    var burger = root.querySelector('[data-pp-burger]');
    var drawer = root.querySelector('[data-pp-drawer]');

    // If a hero opts into overlap, collapse the spacer so the hero sits under the nav
    if (overlap) document.documentElement.classList.add('pp-overlap');

    function onScroll() {
      var y = window.scrollY || window.pageYOffset;

      // Transparent only over a dark hero, near the top
      if (overlap) {
        var threshold = overlap.getBoundingClientRect().height - 96;
        nav.classList.toggle('is-transparent', y < Math.max(threshold, 0));
      } else {
        nav.classList.remove('is-transparent');
      }

      // Scroll progress bar
      if (scrollbar) {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        var p = h > 0 ? y / h : 0;
        scrollbar.style.transform = 'scaleX(' + Math.min(Math.max(p, 0), 1) + ')';
      }
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Drawer
    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      // allow transition after unhide
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.documentElement.classList.add('pp-drawer-open');
      document.body.classList.add('pp-drawer-open');
      if (burger) burger.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('pp-drawer-open');
      document.body.classList.remove('pp-drawer-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      setTimeout(function () { drawer.hidden = true; }, 280);
    }

    if (burger) burger.addEventListener('click', openDrawer);
    if (drawer) {
      drawer.querySelectorAll('[data-pp-drawer-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
      drawer.querySelectorAll('.pp-drawer__link, .pp-drawer__cta').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  function boot() {
    document.querySelectorAll('pp-header').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('pp-header') : null;
    if (root) init(root);
  });
})();
